import React, { useState } from "react";

// assets
import Chevron from "assets/customSVG/Chevron";

// utils
import { useLocation, useNavigate } from "react-router-dom";

// redux
import { useAspSelector } from "test/jest-redux-hooks";
import {
  carouselDiscard,
  templateDiscard,
} from "../../../modules/channels/api/Api";
import { Modal, Skeleton, Tooltip } from "antd";
import NewAlert from "../modal/alert/NewAlert";
import { ICONS } from "../../../assets/icons";

import { getRandomColorsBassedOnLetters } from "../../../helper/colors";
import TeamInbox from "./TeamInbox";
import TagsSection from "./TagsSection";
import VerticalNavSection from "./VerticalNavSection";

export default function SubSideBar({
  isListShow = true,
  list,
  activeNav = "",
  onSelect,
  className,
  numberDetails,
  loading,
  listCounts,
  campaigns,
  campaignsLoading,
  setCampaignsClick,
  fetchCampaignExecutions,
  setShowCampaignExecutions,
  teamMembers,
  teamsLoading,
  setTeamMembersClick,
  tagList,
  addTag,
  removeTag,
}) {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const isSubmenuOpen = useAspSelector((state) => state.Channel.isSubmenuOpen);
  const { currentBrand, currentUser } = useAspSelector((state) => state.app);
  const [discardAlertOpen, setDiscardAlertOpen] = useState(false);
  const templateDetails = useAspSelector((state) => state?.Template);
  const location = useLocation();
  const [hoveredNav, setHoveredNav] = useState(null);

  const [toggle, setToggle] = useState(false);
  const [secondaryToggle, setSecondaryToggle] = useState({
    channels: true,
    team: true,
    campaigns: true,
    tags: true,
  });

  const handleCampaignsClick = (item) => {
    setShowCampaignExecutions(true);
    onSelect(item);
    setCampaignsClick(true);
    fetchCampaignExecutions(currentBrand?.brand_id, item?.id);
    setTeamMembersClick(false);
  };

  const handleTagClick = (item) => {
    // setShowCampaignExecutions(true);
    onSelect(item);
    setTeamMembersClick(false);
    // setCampaignsClick(true);
    // fetchCampaignExecutions(currentBrand?.brand_id, item?.id);
  };

  const handleItemClick = (item) => {
    setShowCampaignExecutions(false);
    if (
      item?.brand_user_id &&
      item?.user_name &&
      location.pathname?.includes("user/inbox")
    ) {
      setTeamMembersClick(true);
    }
    if (item.subMenu) {
      onSelect(item);
      if (location.pathname?.includes("user/inbox")) setTeamMembersClick(false);

      if (
        location.pathname ===
          "/user/channels/whatsapp/edit-template/template-details" &&
        (templateDetails?.details?.status === "PAM" ||
          templateDetails?.details?.status === "APPROVED" ||
          templateDetails?.details?.status === "REJECTED" ||
          templateDetails?.details?.status === "PRM")
      ) {
        {
          setDiscardAlertOpen(true);
        }
      } else {
        item.link && navigate(item.link);
      }

      if (selectedItem === item) {
        setSelectedItem(null);
        setToggle(true);
      } else {
        setSelectedItem(item);
        setToggle(false);
      }
    } else {
      if (
        location.pathname ===
          "/user/channels/whatsapp/edit-template/template-details" &&
        (templateDetails?.details?.status === "PAM" ||
          templateDetails?.details?.status === "APPROVED" ||
          templateDetails?.details?.status === "REJECTED" ||
          templateDetails?.details?.status === "PRM")
      ) {
        setDiscardAlertOpen(true);
      } else {
        onSelect(item);
        item.link && navigate(item.link);
        setSelectedItem(item);
        setToggle(false);
        if (
          !item?.brand_user_id &&
          !item?.user_name &&
          location.pathname?.includes("user/inbox")
        ) {
          setTeamMembersClick(false);
        }
      }
    }
  };

  const discardCarousel = () => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
    };

    // carouselDiscard(templateDetails?.id, payLoad).then((res) => {
    //   if (res?.status === 200) {
    //     setDiscardAlertOpen(false);
    //     navigate("/user/channels/whatsapp/message-templates");
    //   }
    // });

    if (
      location.pathname ===
        "/user/channels/whatsapp/edit-template/template-details" &&
      templateDetails?.categoryType === "CAROUSEL"
    ) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
      };

      carouselDiscard(templateDetails?.id, payLoad).then((res) => {
        if (res?.status === 200) {
          setDiscardAlertOpen(false);
          navigate("/user/channels/whatsapp/message-templates");
        }
      });
    } else if (
      location.pathname ===
        "/user/channels/whatsapp/edit-template/template-details" &&
      templateDetails?.categoryType !== "CAROUSEL"
    ) {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
      };

      templateDiscard(templateDetails?.id, payLoad).then((res) => {
        if (res?.status === 200) {
          setDiscardAlertOpen(false);
          navigate("/user/channels/whatsapp/message-templates");
        }
      });
    }
  };

  return (
    <div
      className={`w-full h-full border-[0.08vw] border-[var(--layoutBorder)] bg-[var(--background)] px-[1.2vw] py-[0.3vw] ${className}`}
    >
      {list?.map((item) => {
        return (
          <>
            {item.type === "divider" ? (
              <div className='w-full contents-[""] border border-[var(--border-50)]'></div>
            ) : (
              <div className="flex-column justify-center" key={item?.id}>
                <div
                  className={`w-full font15px-500 my-[0.5vw] tracking-wide text-[var(--text-black)] cursor-pointer flex items-center justify-between ${
                    !isListShow && item?.link === location?.pathname
                      ? " !bg-[var(--new-primary)] weight-medium rounded-[0.6vw] py-[0.4vw]"
                      : "py-[0.7vw]"
                  }`}
                  onClick={() => {
                    if (isListShow) setToggle(!toggle);
                  }}
                >
                  <div
                    className={`${
                      item?.link !== location?.pathname
                        ? "sidebar-header flex-row align-center"
                        : "!text-[var(--white)] font16px-400 flex-row align-center pl-10"
                    }`}
                    // onClick={() => handleItemClick(item)}
                  >
                    {item?.icon && (
                      <img
                        src={item?.icon}
                        alt="icon"
                        className={`w-25 mr-5 ${toggle ? "rotate-180" : ""} `}
                      />
                    )}
                    {item?.name !== "Facebook" && item?.name}
                  </div>
                  {isSubmenuOpen === false &&
                    item?.icon1 &&
                    isListShow &&
                    item?.name !== "Facebook" && (
                      <Chevron
                        className={`transition-transform duration-300 ease-linear ${
                          toggle ? "rotate-0" : "rotate-180"
                        }`}
                        color={activeNav === item?.name ? "white" : "#0ACD95"}
                        width={"1.1vw"}
                        height={"1.1vw"}
                      />
                    )}
                </div>

                {isSubmenuOpen === false && !toggle && isListShow && (
                  <div className="w-100 flex-column gap-[0.7vw] font-normal weight-normal mr-10">
                    {item?.subMenu?.map((subItem) => {
                      return (
                        <Tooltip
                          title={
                            subItem?.key === "resolved" &&
                            listCounts?.resolved > 0
                              ? `Resolved : ${listCounts?.resolved}`
                              : subItem?.key === "favorited" &&
                                listCounts?.favourite > 0
                              ? `Favorite : ${listCounts?.favourite}`
                              : subItem?.key === "unread" &&
                                listCounts?.unread > 0
                              ? `Unread : ${listCounts?.unread}`
                              : subItem?.key === "your-inbox" &&
                                listCounts?.your_inbox > 0
                              ? `Your Inbox : ${listCounts?.your_inbox}`
                              : subItem?.key === "unassigned" &&
                                listCounts?.unassigned > 0
                              ? `Unassigned : ${listCounts?.unassigned}`
                              : subItem?.key === "unassigned" &&
                                listCounts?.unassigned > 0
                              ? `Unassigned : ${listCounts?.unassigned}`
                              : ""
                          }
                        >
                          <div
                            className={`w-100 b-radius-6 px-[1vw] py-[0.4vw]  flex-row align-center cursor-pointer gap-2.5 ${
                              activeNav === subItem?.name
                                ? "sidebar-sub-header-active ptb-10"
                                : "hover:bg-slate-100 sidebar-sub-header hover:text-[var(--contentBlack)] hover:weight-medium mr-10 ptb-10"
                            }`}
                            key={subItem?.id}
                            onClick={() => handleItemClick(subItem)}
                            onMouseEnter={() => setHoveredNav(subItem?.name)}
                            onMouseLeave={() => setHoveredNav(null)}
                          >
                            {subItem?.icon1 && (
                              <img
                                src={subItem?.icon1}
                                alt="icon"
                                className="w-10"
                              />
                            )}
                            {subItem?.icon && (
                              <subItem.icon
                                color={
                                  activeNav === subItem?.name
                                    ? "var(--new-primary)" // Active nav color
                                    : hoveredNav === subItem?.name
                                    ? "var(--textBlack)" // Apply hover color only if not active
                                    : "#616874" // Default color
                                }
                                applyFill={
                                  activeNav === subItem?.name ?? "var(--a)"
                                  // Default fill
                                }
                                fill={
                                  activeNav === subItem?.name
                                    ? "var(--new-primary)"
                                    : "none"
                                }
                                fillColor={
                                  activeNav === subItem?.name
                                    ? "var(--new-primary)"
                                    : "none"
                                }
                                stroke={
                                  activeNav === subItem?.name
                                    ? "white"
                                    : hoveredNav === subItem?.name
                                    ? "var(--textBlack)"
                                    : "var(--font-600)"
                                }
                                lineColor={
                                  activeNav === subItem?.name
                                    ? "#D8FDD2"
                                    : "var(--font-600)"
                                }
                              />
                            )}
                            {subItem?.assignee !== undefined && (
                              <span
                                className="w-9 h-7 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                                style={{
                                  color: "white",
                                  backgroundColor:
                                    getRandomColorsBassedOnLetters(
                                      currentUser?.first_name
                                        ?.slice(0, 1)
                                        .toUpperCase(),
                                      1.5
                                    ).backgroundColor,
                                }}
                              >
                                {currentUser?.first_name
                                  ?.slice(0, 1)
                                  .toUpperCase()}
                              </span>
                            )}
                            <div className="w-100 flex-row align-center space-between">
                              <span>
                                {subItem?.name}
                                {subItem?.send_from_phone_name &&
                                  numberDetails?.[0]?.send_from_phone_name}
                              </span>

                              {subItem?.key && (
                                <span
                                  className={`text-[white] text-[0.65rem] font-[600] py-0.45 px-2 rounded-lg ${
                                    subItem?.key === "unread"
                                      ? "bg-[#FF543E]"
                                      : "bg-[#6940F2]"
                                  }`}
                                >
                                  {subItem?.key === "resolved" &&
                                    listCounts?.resolved > 0 &&
                                    (listCounts?.resolved > 99
                                      ? "99+"
                                      : listCounts?.resolved)}

                                  {subItem?.key === "your-inbox" &&
                                    listCounts?.your_inbox > 0 &&
                                    (listCounts?.your_inbox > 99
                                      ? "99+"
                                      : listCounts?.your_inbox)}

                                  {subItem?.key === "favorited" &&
                                    listCounts?.favourite > 0 &&
                                    (listCounts?.favourite > 99
                                      ? "99+"
                                      : listCounts?.favourite)}
                                  {subItem?.key === "unread" &&
                                    listCounts?.unread > 0 &&
                                    (listCounts?.unread > 99
                                      ? "99+"
                                      : listCounts?.unread)}
                                  {subItem?.key === "unassigned" &&
                                    listCounts?.unassigned > 0 &&
                                    (listCounts?.unassigned > 99
                                      ? "99+"
                                      : listCounts?.unassigned)}
                                  {/* {subItem?.key === "all-conversations" &&
                                    listCounts?.all_conversation > 0 &&
                                    (listCounts?.all_conversation > 99
                                      ? "99+"
                                      : listCounts?.all_conversation)} */}
                                </span>
                              )}
                            </div>
                          </div>
                        </Tooltip>
                      );
                    })}
                  </div>
                )}
                {location?.pathname === "/user/inbox" && (
                  <>
                    <div
                      className="flex-row align-center sidebar-header py-2 pointer"
                      onClick={() => {
                        setSecondaryToggle((prevState) => ({
                          ...prevState,
                          channels: !prevState.channels,
                        }));
                      }}
                    >
                      <img
                        src={ICONS?.sidebarChevronDown}
                        alt="icon"
                        // className="w-3 mr-10"
                        className={`w-3 mr-10 ${
                          secondaryToggle["channels"] ? "" : "rotate-180"
                        }`}
                      />
                      <span>Channels</span>
                    </div>
                    {secondaryToggle["channels"] && (
                      <Skeleton
                        active
                        style={{
                          width: "20vw",
                          padding: "20px",
                        }}
                        loading={loading}
                        paragraph={{ rows: 2 }}
                        className=".ant-skeleton-paragraph >li +li"
                      >
                        {numberDetails?.map((numberItem, index) => {
                          return (
                            <div
                              key={index}
                              onClick={() => {
                                handleItemClick(numberItem);
                              }}
                              className={`w-[91.5%] b-radius-6 flex-row align-center px-[1vw] py-[0.7vw] pl-[15px] mt-10 gap-2 pointer ${
                                activeNav === numberItem?.send_from_phone_name
                                  ? "sidebar-sub-header-active"
                                  : "sidebar-sub-header hover:bg-slate-100"
                              }`}
                            >
                              <Tooltip
                                title={`${
                                  numberItem?.send_from_phone_name || ""
                                } - ${
                                  numberItem?.send_from_phone_number || ""
                                }`}
                              >
                                <div className="flex flex-row gap-2.5 truncate w-100 items-center">
                                  <img
                                    src={ICONS?.whatsappInbox}
                                    alt="whatsApp"
                                    className="h-4 w-4" // Adjust the size as needed
                                  />
                                  <span className="truncate">
                                    {numberItem?.send_from_phone_name} -{" "}
                                    {numberItem?.send_from_phone_number}
                                  </span>
                                </div>
                              </Tooltip>
                            </div>
                          );
                        })}
                      </Skeleton>
                    )}
                  </>
                )}
                {/* {location?.pathname === "/user/inbox" && (
                  <VerticalNavSection
                    title="Campaigns"
                    setSecondaryToggle={setSecondaryToggle}
                    secondaryToggle={secondaryToggle}
                    items={campaigns || []}
                    loading={campaignsLoading}
                    handleItemClick={handleCampaignsClick}
                    activeNav={activeNav}
                  />
                )} */}
                {location?.pathname === "/user/inbox" && (
                  <TeamInbox
                    setSecondaryToggle={setSecondaryToggle}
                    secondaryToggle={secondaryToggle}
                    teamMembers={teamMembers}
                    loading={teamsLoading}
                    handleItemClick={handleItemClick}
                    activeNav={activeNav}
                  />
                )}
                {location?.pathname === "/user/inbox" && (
                  <TagsSection
                    setSecondaryToggle={setSecondaryToggle}
                    secondaryToggle={secondaryToggle}
                    tags={tagList}
                    loading={false}
                    // handleItemClick={handleItemClick}
                    activeNav={activeNav}
                    addTag={addTag}
                    removeTag={removeTag}
                    handleTagClick={handleTagClick}
                  />
                )}
              </div>
            )}
          </>
        );
      })}

      <Modal
        // open={isDuplicateModal}
        styles={{ content: { padding: 0 } }}
        footer={null}
        open={discardAlertOpen}
        className={"asp-modal-popup-small"}
        closable={false}
        centered={true}
        wrapClassName={"bg-[#00000095]"}

        // onCancel={handleCancel}
      >
        <NewAlert
          type="new"
          open={discardAlertOpen}
          icon={ICONS?.AlertIcon}
          setOpen={setDiscardAlertOpen}
          content={
            <div>
              <p>
                You have made some changes in the template. How would you like
                to proceed.
              </p>
            </div>
          }
          // title={"Restore Template?"}
          noName="Continue Editing"
          yesName="Discard"
          noButtonClassName="!font-md !weight-semibold"
          handleNo={() => {
            discardCarousel();
          }}
          handleYes={() => {
            setDiscardAlertOpen(false);
          }}
        />
      </Modal>
    </div>
  );
}
